import api from '../api/client';

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null;

async function getRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) return null;
  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('[push] sw.js register falhou', e);
      return null;
    });
  }
  return registrationPromise;
}

/**
 * Registra service worker + cria/atualiza subscription Web Push e envia pro back.
 * Idempotente: se já tem subscription ativa, re-envia (pro back atualizar last_seen_at).
 * Não pede permissão sozinho — assume que Notification.permission já foi tratado.
 */
export async function setupPushSubscription(): Promise<boolean> {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
    if (Notification.permission !== 'granted') return false;

    // 1. busca chave pública
    const r = await api.get('/push/public-key');
    const publicKey: string | undefined = r.data?.publicKey;
    const enabled: boolean = !!r.data?.enabled;
    if (!enabled || !publicKey) {
      console.warn('[push] backend não tem VAPID configurado');
      return false;
    }

    // 2. registra SW
    const reg = await getRegistration();
    if (!reg) return false;

    // 3. cria/atualiza subscription
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      const key = urlBase64ToUint8Array(publicKey);
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        // Cast: tipos do TS apertam pra ArrayBuffer puro; runtime aceita BufferSource.
        applicationServerKey: key.buffer as ArrayBuffer,
      });
    }

    // 4. manda pro back
    const json = sub.toJSON() as { endpoint: string; keys: { p256dh: string; auth: string } };
    await api.post('/push/subscribe', {
      endpoint: json.endpoint,
      keys: json.keys,
      userAgent: navigator.userAgent,
    });
    return true;
  } catch (e) {
    console.warn('[push] setupPushSubscription falhou', e);
    return false;
  }
}

export async function unsubscribePush(): Promise<void> {
  try {
    const reg = await getRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const endpoint = sub.endpoint;
    await sub.unsubscribe();
    await api.delete('/push/unsubscribe', { data: { endpoint } });
  } catch (e) {
    console.warn('[push] unsubscribePush falhou', e);
  }
}
